import { useEffect } from "react";
import { useApi } from "../../../hooks/useApi";
import { useRedux } from "../../../hooks/useRedux";
import UtilsContractsService from "../../../services/utilsContracts.service";

const { getMaxMinByDeposit } = new UtilsContractsService();

export function useMaxMinByDeposit() {
  const {
    data: {
      clientPersist: { uuid },
    },
  } = useRedux();

  const {
    data: dataMaxMinByDeposit = {
      amountMin: 0,
      amountMax: 232000,
    },
    error: errorMaxMinByDeposit,
    execute: execGetMaxMinByDeposit,
    isLoading: isLoadingMaxMinByDeposit,
  } = useApi<
    {
      amountMin: number;
      amountMax: number;
    },
    { processId: string }
  >(getMaxMinByDeposit);

  useEffect(() => {
    return () => {
      execGetMaxMinByDeposit({ processId: uuid });
    };
  }, []);

  return {
    dataMaxMinByDeposit,
    isLoadingMaxMinByDeposit,
    errorMaxMinByDeposit,
  };
}
